import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { MatchingFilterService } from 'src/app/shared/service/matching-filter.service';
import { MatchingFilter } from 'src/app/shared/model/matching-filter.model';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { AutoSearchConditionGroup } from 'src/app/shared/model/auto-search-condition-group.model';
import { SearchAutoService } from '../../../service/search/search-auto.service';
import { Subscription } from 'rxjs';
import { SearchPage } from 'src/app/shared/model/search-page.model';
import { SearchCount } from '../../../model/search-count.model';
import { SearchTag } from '../../../model/search-tag.model';
import { SearchTagService } from '../../../service/search-tag.service';
import { PageEnums } from 'src/app/shared/enum/page-enums';

@Component({
  selector: 'app-auto-matching-search-section',
  templateUrl: './auto-matching-search-section.component.html',
  styleUrls: ['./auto-matching-search-section.component.scss']
})
export class AutoMatchingSearchSectionComponent implements OnInit, OnDestroy {
  @Output() searching = new EventEmitter<any>();
  @Output() searchFinish = new EventEmitter<any>();
  @Input() autoSearchConditionGroup: AutoSearchConditionGroup;
  searchParams: SearchCondition;
  lastSearchParams: string;
  filters: Array<MatchingFilter>;
  searchKeywords = '';
  private subscriptions: Subscription = new Subscription();
  searchTags: Array<SearchTag> = [];
  page = PageEnums.auto;
  column_orders = {
    fee: 0,
    age: 1,
    number_of_connect_company: 2,
    employment_status: 3,
    country_of_citizenship: 4,
    work_immidiately: 5,
    interview_times: 6
  };

  workerSection = false;
  projectSection = false;

  constructor(
    private searchTagService: SearchTagService,
    private matchingFilterService: MatchingFilterService,
    public searchService: SearchAutoService
  ) {}

  ngOnInit() {
    // 検索開始イベント受信時時の処理
    const searchStartSub = this.searchService.searchStartState.subscribe(res => {
      this.doSearch();
    });
    this.subscriptions.add(searchStartSub);

    // 検索リセットイベント受信時時の処理
    const searchResetSub = this.searchService.searchResetState.subscribe(res => {
      this.resetSearch();
    });
    this.subscriptions.add(searchResetSub);

    this.searchParams = this.autoSearchConditionGroup.auto;
    const matchingFilterSub = this.matchingFilterService.getMatchingFilters().subscribe(res => {
      this.filters = res.body.matching_filters.sort(
        (a, b) => this.column_orders[a.column] - this.column_orders[b.column]
      );
    });
    this.subscriptions.add(matchingFilterSub);

    this.getSearchTags();
    this.resetSearchTags();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  clickedTag(): void {
    // アクティブになってるTagのIDを抽出
    const activatedTagIds = this.searchTagService.getActivatedTagIds(
      this.searchTags
    );
    // sessionStorageに保存
    this.searchService.setSearchTags(activatedTagIds);
    // 検索実行
    this.doSearch();
  }

  getSearchTags(): void {
    const params = { search_side: 'project' };
    const searchTagsSub = this.searchTagService.getSearchTags(params).subscribe(res => {
      // おすすめ画面では赤タグの表示項目を絞る
      const targetTagNames = ['自社', '★注力', '新規/再送なし', '未読'];
      this.searchTags = res.body.search_tags.filter(
        item => item.tag_type === 'qoala_tag' && targetTagNames.includes(item.tag_name)
      );
    });
    this.subscriptions.add(searchTagsSub);
  }

  resetSearchTags(): void {
    this.searchService.setSearchTags([]);
    this.searchTags.map(searchTag => (searchTag.is_activated = false));
  }

  show_option(val: boolean): string {
    return val ? '表示' : '非表示';
  }

  resetSearchkeyword(): void {
    this.searchParams.keyword = '';
    this.clickSearch();
  }

  clickSearch() {
    this.autoSearchConditionGroup.matching_filters = this.filters;
    const currentSearchParams = JSON.stringify(this.autoSearchConditionGroup);
    if (currentSearchParams !== this.lastSearchParams) {
      this.doSearch();
    }
    this.lastSearchParams = currentSearchParams;
  }

  doSearch() {
    // クリック時に条件保存：検索条件をサービスに設定
    this.searching.emit();
    this.searchService.setSearchCondition(this.autoSearchConditionGroup);
    this.searchService.setSearchPage(new SearchPage({ page: 1 }));
    // 検索ボタン・リセットボタンを連打した時に、リクエストを複数送らないようにする処理
    this.subscriptions.unsubscribe();
    this.subscriptions = new Subscription();
    const searchSub = this.searchService.search().subscribe(res => {
      // 使用中のseachSearviceの名前からsessionStorageで使用するkey名作成
      const searchParamsKeyName = `${this.searchService.constructor.name}SearchParams`;
      // sessionStorageにページ数の情報保存
      this.setSearchCount(res);
      // sessionStorageに検索窓に入力されたパラメータ保存
      this.setSearchParams(searchParamsKeyName, res);
      // 人材、案件どちらの検索窓を使用したかをsessionStorageに保存
      this.setSearchSide(searchParamsKeyName, res);
      // 値を他コンポーネントに移譲
      this.searchService.searchSubject.next(res.body);
      this.searchFinish.emit();
    });
    this.subscriptions.add(searchSub);
  }

  resetSearch(): void {
    this.autoSearchConditionGroup = new AutoSearchConditionGroup({});
    this.searchParams = this.autoSearchConditionGroup.auto;
    this.resetSearchTags();
    this.clickSearch();
  }

  setSearchCount(res: any) {
    const searchCount = new SearchCount({
      startCount: res.body.pageInfo.start_count,
      endCount: res.body.pageInfo.end_count,
      totalCount: res.body.pageInfo.total,
      perPage: this.searchService.getSearchCount().perPage
    });
    this.searchService.setSearchCount(searchCount);
  }

  setSearchParams(searchParamsKeyName: string, res: any) {
    sessionStorage.setItem(
      searchParamsKeyName,
      JSON.stringify(res.body.searchParams)
    );
  }

  setSearchSide(searchParamsKeyName: string, res: any) {
    sessionStorage.setItem(
      'searchAutoSearchSide',
      JSON.stringify(res.body.searchParams.activeTabId)
    );
  }

  EnterOnSearchBox(event): void {
    if (event.key === 'Enter' && !event.isComposing) {
      event.preventDefault();
      this.clickSearch();
    }
  }
  toggle(value: string): void {
    if (value === 'worker') {
      this.workerSection = !this.workerSection;
      this.scrollToSection('worker-section');
    } else if (value === 'project') {
      this.projectSection = !this.projectSection;
      this.scrollToSection('project-section');
    }
  }
  scrollToSection(section: 'worker-section' | 'project-section'): void {
    setTimeout(() => {
      document
        .getElementById(section)
        .scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 200);
  }
}
